"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Get =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Get, _React$Component);

  function Get(props, context) {
    var _this;

    _classCallCheck(this, Get);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Get).call(this, props, context));
    _this.fetchData = _this.fetchData.bind(_assertThisInitialized(_this));
    _this.state = {
      data: null
    };

    if (_this.props.initialDelay) {
      setTimeout(function () {
        return _this.fetchData();
      }, _this.props.initialDelay);
    } else {
      _this.fetchData();
    }

    return _this;
  }

  _createClass(Get, [{
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;

      clearTimeout(this.timeout);
      var get = this.props.getFunction || window.fetch;
      get(this.props.url, this.props.options).then(this.props.mapData).then(function (data) {
        if (_this2.props.hasChanged) {
          if (_this2.props.hasChanged(_this2.state.data, data)) {
            _this2.setState({
              data: data
            });
          }
        } else {
          _this2.setState({
            data: data
          });
        }

        if (_this2.props.poll) {
          _this2.timeout = setTimeout(function () {
            if (_this2.mounted) {
              _this2.fetchData();
            }
          }, _this2.props.pollingInterval);
        }
      })["catch"](function (error) {
        _this2.props.onFailed(error);

        if (_this2.props.poll || _this2.props.retryOnFail) {
          _this2.timeout = setTimeout(function () {
            if (_this2.mounted) {
              _this2.fetchData();
            }
          }, _this2.props.pollingInterval);
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.stop && this.props.stop !== prevProps.stop) {
        if (this.timeout) {
          clearTimeout(this.timeout);
          this.timeout = null;
        } // eslint-disable-next-line react/no-did-update-set-state


        this.setState({
          data: null
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        data: this.state.data
      });
    }
  }]);

  return Get;
}(_react["default"].Component);

Get.propTypes = {
  /**
   * Render function
   */
  children: _propTypes["default"].func,

  /**
   * Url to data
   */
  url: _propTypes["default"].string.isRequired,

  /**
   * fetch function. defaults to window.fetch
   */
  getFunction: _propTypes["default"].func,

  /**
   * Override this to reduce rerenders when polling. (old, nu) => ...
   */
  hasChanged: _propTypes["default"].any,

  /**
   * Override to shape data before it returns in function.
   */
  mapData: _propTypes["default"].func,

  /**
   * Callback when a get fails
   */
  onFailed: _propTypes["default"].func,

  /**
   * Options sent to the fetch function. Headers, body, params etc...
   */
  options: _propTypes["default"].object,

  /**
   * If true will poll url every *pollingInterval*
   */
  poll: _propTypes["default"].bool,

  /**
   * Interval in which polling will be done. Ignored if poll == false
   */
  pollingInterval: _propTypes["default"].number,

  /**
   * Initial delay
   */
  initialDelay: _propTypes["default"].number
};
var _default = Get;
exports["default"] = _default;
Get.defaultProps = {
  mapData: function mapData(item) {
    return item;
  },
  onFailed: console.error,
  options: {},
  poll: false,
  pollingInterval: 5000,
  initialDelay: 0
};